/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="col-lg-12"
    style="padding-left: 0;"
  >
    <div
      v-for="attachment in assignment.attachments"
      :ref="'attachment-' + attachment.id"
      :class="attachmentType(attachment) === 'recording' ? 'attachment audioPlayback' : 'attachment attachLink'"
    >
      <div class="attachment-row">
        <div class="attachment-info">
          <svg
            v-if="attachmentType(attachment) === 'link'"
            class="icon-file"
          >
            <use xlink:href="/static/svg-symbols.svg#icon-file" />
          </svg>
          <!-- Links -->
          <a
            v-if="attachmentType(attachment) === 'link'"
            :href="attachment.attachmentUrl"
            style="margin-right: 8px;"
            target="_blank"
          >
            {{ attachment.name }}
          </a>
          <span
            v-if="attachmentType(attachment) === 'recording'"
          >
            {{ attachment.name }}
          </span>
        </div>
        <div
          v-if="showTrashCan"
          tabindex="0"
          aria-label="delete attachment"
          role="button"
          class="assignment-trash"
          @click.prevent="deleteAttachment(attachment)"
        >
          <svg class="svgicon icon-trash">
            <use xlink:href="/static/svg-symbols.svg#icon-trash" />
          </svg>
        </div>
      </div>
      <div
        v-if="attachmentType(attachment) === 'recording'"
        class="assignment-row"
      >
        <div style="display: table-cell">
          <!-- Recordings -->
          <audio
            v-if="attachmentType(attachment) === 'recording'"
            controls
          >
            <source
              :src="attachment.attachmentUrl || attachment.playbackUrl"
              type="audio/mp3"
            >
            Your browser does not support the audio tag.
          </audio>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  audio {
    display: block;
  }
  .attachment-row {
    display: table-row;
  }
  .attachment-trash {
    display: table-cell;
    width: 20px;
  }
  .icon-file {
    height: 14px; width: 14px;
  }
  .attachment-info {
    display: table-cell;
    width: 290px;
  }
  .attachment {
    font-size: 12px;
    font-weight: 400;
    display: inline-block;
    padding: 5px;
    margin-bottom: 15px;
    margin-right: 50px;
    width: 310px;
    @media (max-width: 646px) {
      width: 270px;
    }
    height: 115px;
    background-color: white;
    text-align: left;
    border-radius: 8px;
  }
  .attachment.audioPlayback {
    text-align: left;
  }
  .attachment-deleted {
    opacity: 0;
    transition: opacity 1s linear;
  }
  .svgicon {
    display: inline-block;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
  .icon-trash {
    width: 18px; height: 18px;
  }
</style>

<script>
export default {
  props: ['assignment', 'showTrashCan'],
  data() {
    return {};
  },
  methods: {
    deleteAttachment(attachment) {
      if (!attachment.id) {
        return alert('Cannot delete this item. Please click reload on your browser and try again');
      }
      if (window.confirm(`Delete supporting material: ${attachment.name}?`)) {
        this.$store.dispatch('deleteAttachment', attachment).then(() => {
          this.$announcer.set('attachment deleted');
          return this.$emit('attachmentDeleted');
        });
      }
    },
    attachmentType(attachment) {
      const type = attachment.attachmentType;
      const filename = (attachment.attachmentUrl) ? attachment.attachmentUrl : '';
      if (type === 'recording' || filename.indexOf('.mp3') !== -1 || filename.indexOf('.wav') !== -1) {
        return 'recording';
      }
      return 'link';
    }
  }
};
</script>
